import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { environment } from '../../../environments/environment';

import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class ClasseService {
    private _Url = environment.UrlPrincipal + '/api/classe';
    private _urlRestaurar = environment.UrlApi + '/classe-restaurar';

    constructor(private http: HttpClient) {}

    listSemPlano(sem_plano = null) {
        return this.http
            .get(this._Url + '?sem_plano=true')
            .catch(this.handleError);
    }

    list(inativo) {
        if (inativo == false) {
            return this.http
                .get(this._Url + '?inativos=false')
                .catch(this.handleError);
        } else {
            return this.http
                .get(this._Url + '?inativos=true')
                .catch(this.handleError);
        }
    }

    find(id) {
        return this.http.get(this._Url + '/' + id).catch(this.handleError);
    }

    save(dados, codigo): Observable<any> {
        let http;
        if (codigo) {
            http = this.http.put(this._Url + '/' + codigo, dados);
        } else {
            http = this.http.post(this._Url, dados);
        }
        http.map((res) => {
            return res;
        }).catch(this.handleError);
        return http;
    }

    delete(codigo) {
        return this.http.delete(this._Url + '/' + codigo);
    }

    private handleError(error: Response) {
        return error.json();
    }

    restore(codigo_classe) {
        return this.http.put(this._urlRestaurar + '/' + codigo_classe, null);
    }
}
